import { render } from "./Localization.vue?vue&type=template&id=e44c04fa"
import script from "./Localization.vue?vue&type=script&lang=ts"
export * from "./Localization.vue?vue&type=script&lang=ts"
script.render = render

export default script